class HeaderMenu {

    constructor(element) {

        this.active         = null;
        this.header         = element;
        this.mainMenu       = element.querySelector('.navigation');
        this.menuItems      = element.querySelectorAll('#main-menu > .menu-item > a');
        this.globalfinder   = element.querySelector('.finder-icon');
        this.search         = element.querySelector('.search-icon');

        if( this.menuItems.length > 0 ){
            // .bind(this) makes "this" refer to the Class so we can use class methods
            Array.from(this.menuItems).forEach( item => item.addEventListener( 'mouseenter', this.openDropdown.bind(this) ) ) 
        }

        if( this.globalfinder ){
            this.globalfinder.addEventListener( 'click', this.handleItemClick.bind(this));
        }
        
        if( this.search ){
            this.search.addEventListener( 'click', this.handleItemClick.bind(this));
        }

        // Need this to add/remove eventlistener on keyboard key press
        this.handleKeypress = this.handleKeypress.bind(this);
        this.closeDropdown = this.closeDropdown.bind(this);

        this.add_images();

    }

    openDropdown(e){

        if( this.active && e.currentTarget.parentElement != this.active ){
            this.active.classList.remove('open');
        }

        this.active = e.currentTarget.parentElement;
        this.active.classList.add('open');
        this.mainMenu.addEventListener( 'mouseleave', this.closeDropdown );
        window.addEventListener( 'keydown', this.handleKeypress );

    }
    
    closeDropdown(){
        this.active.classList.remove('open');
		this.mainMenu.removeEventListener( 'mouseleave', this.closeDropdown );
		window.removeEventListener( 'keydown', this.handleKeypress );
        this.active = null;
    }

    handleKeypress(e){
        if( e.key != "Escape" ){
            return;
        }
        return this.closeDropdown();
    }

    handleItemClick(e){
        
        if( this.active && e.currentTarget.parentElement == this.active ){
            this.closeDropdown();
        }else{
            this.openDropdown(e);
        }

    }

    add_images(){

        const el = document.querySelectorAll( '.menu .menu-item.has-image' );

        if( el.length > 0 ){
            Array.from(el).forEach( item => {
                const url = item.dataset.image;
                if( url ){
                    let image = document.createElement('img');
                    image.src = url;
                    image.className = 'menu-image';
                    item.querySelector('.sub-menu-container__inner').appendChild(image);
                }
            } )
        }

    }

}

export { HeaderMenu };